/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_FilesInputs */

const en_portal_nav_files = /** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const ar_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const he_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const ur_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const es_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const fr_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const de_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const pt_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const hi_portal_nav_files = en_portal_nav_files;

/** @type {(inputs: Portal_Nav_FilesInputs) => LocalizedString} */
const bn_portal_nav_files = en_portal_nav_files;

/**
* | output |
* | --- |
* | "Files" |
*
* @param {Portal_Nav_FilesInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_files = /** @type {((inputs?: Portal_Nav_FilesInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_FilesInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_files(inputs)
	if (locale === "he") return he_portal_nav_files(inputs)
	if (locale === "ur") return ur_portal_nav_files(inputs)
	if (locale === "es") return es_portal_nav_files(inputs)
	if (locale === "fr") return fr_portal_nav_files(inputs)
	if (locale === "de") return de_portal_nav_files(inputs)
	if (locale === "pt") return pt_portal_nav_files(inputs)
	if (locale === "hi") return hi_portal_nav_files(inputs)
	if (locale === "bn") return bn_portal_nav_files(inputs)
	return /** @type {LocalizedString} */ ("Files")
});